export default __webpack_public_path__ + "static/media/preview.a2b0cb0b.png";